import styled from 'styled-components';

export const PageContent = styled.div`
  padding: 50px 0;
  width: 100%;
`;
